// 过滤器
// 货币符号
const lang = localStorage.getItem('lang')
let money_symbol = ""
switch (lang) {
    case 'zh_cn':
        money_symbol = "¥"
        break;
    case 'ms_my':
        money_symbol = "MR"
        break;
    case 'id_id':
        money_symbol = "Rp"
        break;

}

// 格式化金额
const formatAmount = (amount) => {
    let num = Number(amount)
    if (!num || isNaN(num)) num = 0
    num = Math.round(num * 100) / 100
    const symbol = num < 0 ? '-' : ''

    // 将数值转为字符串
    const numStr = `${Math.abs(num)}`

    let [integer, decimals] = numStr.split('.')
    if (!decimals) decimals = "00"
    else if (decimals.length == 1) decimals = `${decimals}0`

    // 对整数部分进行格式化
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return `${symbol}${money_symbol}${integer}.${decimals}`
}

export {
    formatAmount
}